// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"PN-z","carouselContainer":"QN-z"};